import { type Theme, Typography } from "@mui/material"
import type { CSSProperties, PropsWithChildren } from "react"

export interface AsideSectionSummaryMainSubTitleProps {
  subtitleColor?: CSSProperties["color"] | ((theme: Theme) => string)
}

export const AsideSectionSummaryMainSubTitle = ({
  subtitleColor,
  children,
}: PropsWithChildren & AsideSectionSummaryMainSubTitleProps) => {
  return (
    <Typography
      variant="12px"
      fontWeight={500}
      mb={1.5}
      sx={{ color: subtitleColor || "#81adf8" }}
    >
      {children}
    </Typography>
  )
}
